import { WaitlistForm } from "./WaitlistForm";
import { SlackMockup } from "./SlackMockup";

interface HeroProps {
  count: number;
}

export function Hero({ count }: HeroProps) {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-left">
            <div className="hero-eyebrow">Now boarding - Slack-native AI accountant</div>
            <h1>
              Your accountant<br />
              <em>lives in Slack</em><br />
              <span className="strike">not your inbox.</span>
            </h1>
            <p className="hero-lede">
              Stop wrangling spreadsheets at 11pm. <strong>Just @ask digis</strong> - books reconciled, invoices sent, suppliers paid, trial balance closed. All in the channel where your team already lives. Built for SMBs that need a real accountant, not another dashboard.
            </p>

            <WaitlistForm />

            <div className="form-meta">
              <span className="counter">#{(count + 1).toLocaleString()}</span>
              <span>- Free for the first 100. No credit card.</span>
            </div>
          </div>

          <div className="hero-right">
            <SlackMockup />
          </div>
        </div>
      </div>
    </section>
  );
}
